import { render, staticRenderFns } from "./FaaDocumentsOverview.vue?vue&type=template&id=0fc84db0&"
import script from "./FaaDocumentsOverview.vue?vue&type=script&lang=js&"
export * from "./FaaDocumentsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports